import React from 'react'
import { usePaginationFragment, graphql } from 'react-relay'
import { Trans } from '@lingui/react/macro'

import { YStack, XStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { AutoLoadMore } from '@newComponents/AutoLoadMore'
import { PresentationCard } from '@newComponents/Presentation/PresentationCard'

import { GuildPresentationsScreenOtherPresentationsSection_guild$key } from './__generated__/GuildPresentationsScreenOtherPresentationsSection_guild.graphql'

export const GuildPresentationsScreenOtherPresentationsSection = ({
  guild,
}: {
  guild: GuildPresentationsScreenOtherPresentationsSection_guild$key
}) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment GuildPresentationsScreenOtherPresentationsSection_guild on Guild
      @refetchable(
        queryName: "GuildPresentationsScreenOtherPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        otherPresentations: presentationsByEventTimeSelection(
          first: $count
          after: $cursor
          timeSelection: OTHER
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "GuildPresentationsScreenOtherPresentationsSection_guild_otherPresentations"
          ) {
          edges {
            node {
              ...PresentationCardNew_presentation
            }

            cursor
          }
        }
      }
    `,
    guild
  )

  if (data.otherPresentations.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$4'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$color'>
          <Trans>Other Presentations</Trans>
        </Strong>
        <Separator borderColor='$borderColor' />
      </XStack>

      {data.otherPresentations.edges.map((edge) => {
        return (
          <PresentationCard
            key={edge.cursor}
            presentation={edge.node}
            numberOfLines={8}
          />
        )
      })}

      <AutoLoadMore
        hasNext={hasNext}
        loadNext={loadNext}
        isLoadingNext={isLoadingNext}
        count={3}
      />
    </YStack>
  )
}
